<template>
<div class="certList" :class="{white:list.length==0 && type=='certForm'}">
  <van-nav-bar
      v-show="type!='miniWeap'"
      ref="nav"
      :border="false"
      @click-left="back"
      placeholder
      :fixed="true"
      :title="type=='h5' ? '证书列表' : '证书查询'"
    >
      <template #left>
        <van-icon size="20px" name="arrow-left" color="#333" />
      </template>
    </van-nav-bar>
  <div class="main" id="main">
      <div class="list" v-if="list.length">
         <div class="listItem" v-for="(item,index) in list">
            <div class="title">
               <p class="ellipsis">{{item.cert_name}}</p>
               {{item.day_time}}
            </div>
             <cert-save-587 v-if="item.discipline_id == 1228" :lessonNm="item.cert_name" :certInfoItem="item" :userInfoItem="user_list" :index="index" type="true"></cert-save-587>
             <cert-save-588 v-else-if="item.discipline_id == 1229" :lessonNm="item.cert_name" :certInfoItem="item" :userInfoItem="user_list" :index="index" type="true"></cert-save-588>
            <cert-save v-else :lessonNm="item.cert_name" :certInfoItem="item" :userInfoItem="user_list" :index="index" type="true"></cert-save>
            <!-- <cert-save-t-j :lessonNm="item.cert_name" :certInfoItem="item" :userInfoItem="user_list" :index="index" type="true" v-else></cert-save-t-j> -->
         </div>
      </div>
      <div class="noData" v-else-if="type!='certForm'">
        <img src="https://pkusaas.oss-cn-beijing.aliyuncs.com/miniprogram/study_center/%E7%A9%BA%E7%8A%B6%E6%80%81%E5%9B%BE%402x.png"/>
        <p>暂无证书</p>
      </div>
      <div class="noDataCert" v-else>
        <div class="noDataTop">
          <img src="https://pkusaas.oss-cn-beijing.aliyuncs.com/miniprogram/study_center/tuoyu2/certListNo.png"/>
          对不起，没有查询到相关信息
        </div>
        <div class="noDataContent">
          <b>该怎么办？</b>
          <p>1.请确认您输入了正确的证书编号、证件号码或姓名</p>
          <p>2.若无法查询到证书，请联系客服：<a href="tel:13811674685">13811674685</a></p>
        </div>
      </div>
  </div>
</div>
</template>

<script>
  import CertSave from './CertSave.vue';
  import CertSaveTJ from './CertSaveTJ.vue';
  import CertSave587 from "./CertSave587.vue";
import CertSave588 from "./CertSave588.vue";
export default {
  components: {CertSave, CertSaveTJ, CertSave587, CertSave588},
  name: "cert",
  data() {
    return {
      user_list:null,
      list:[],
      type:'h5',
      form: {
        username:'',
        // uicd:'',
        mobile:'',
        cert_no:'',
        code:'',
      },
    }
  },
  mounted() {
    this.$toast.loading({
      message: '加载中...',
      forbidClick: true,
    });
    this.type = this.$route.query.type || 'h5'
    if(this.type=='certForm'){
      this.form = JSON.parse(this.$route.query.form)
      this.getList()
    }
    if(this.$route.query.type=='miniWeap'){
      document.title='证书查询'
      this.type = this.$route.query.type
      this.form.username = this.$route.query.username
      this.form.mobile = this.$route.query.mobile
      this.form.cert_no = this.$route.query.cert_no
      this.form.code = this.$route.query.code
      // this.form.uicd = this.$route.query.uicd
      this.getList()
    }else{
      this.$request.certList({flat_id:this.plat}).then(res=>{
        this.$toast.clear()
        if(res.code==0){
          this.list = res.data.cret_list
          this.user_list = res.data.user_list
        }else{
          this.$toast(res.msg)
        }
      })
    }
    
  },
  destroyed() {},
  computed: {
    plat() {
      return this.$store.state.plat_id
    }
  },
  methods: {
    async getList(){
      let res = await this.$request.certSearch2(this.form)
      if(res.code == 1){
        this.ifForm = false
        return
      }
      if(res.code==0) {
        this.ifForm = false
        this.list = res.data && res.data.cret_list || []
        this.user_list = res.data.user_list
      }else{
        this.list = []
        this.$toast(res.msg)
      }
      this.$toast.clear()
    },
    
    back() {
      this.$router.go(-1);
    },
    
  },
  beforeRouteUpdate(to, from, next) {
    console.log('beforeRouteUpdate')
    console.log(to)
    next()
  },
  beforeDestroy(){
    clearInterval(this.timer)
  }

};
</script>

<style lang="scss" scoped>

.certList {
  height: 100vh;
  display: flex;
  flex-direction: column;
  background: #F7F8FA;
  align-items: center;
  padding: 50px 0;
    .main{
      overflow-y: auto;
      -webkit-overflow-scrolling: touch;
      flex: 1;
      padding: 0 30px;
      width: 100%;;
      .list{
        .listItem{
          margin-bottom: 48px;
          .title{
            display: flex;
            color: #666;
            font-size: 28px;
            padding-bottom: 24px;
            align-items: flex-end;
            p{
              flex: 1;
              color: #333333;
              font-size: 36px;
              font-weight: bold;
            }
          }
        }
      }
      .noData{
        text-align: center;
        font-size: 30px;
        color: #9FA2B3;
        padding-top: 250px;
        img{
          width: 300px;
          height: 222px;
          margin-bottom: 50px;
        }
      }
      .noDataCert{
        padding-top: 100px;
        .noDataTop{
          color: #333;
          font-size: 34px;
          display: flex;
          align-items: center;
          flex-direction: column;
          margin-bottom: 60px;
          img{
            margin-bottom: 15px;
            width: 150px;
          }
        }
        .noDataContent{
          padding: 36px;
          background-color: #fafafa;
          b{
            display: block;
            font-size: 28px;
            color: #242424;
            margin-bottom: 15px;
          }
          p{
            color: #666666;
            font-size: 24px;
            line-height: 50px;
            a{
              color: #666666;
            }
          }
        }
      }
    }
  }
.white{
  background-color: #fff;
  padding: 0;
  .main{
    border-top: 1px solid #f7f8fa;
  }
}
</style>

